export const DAYS = [
  "Diumenge",
  "Dilluns",
  "Dimarts",
  "Dimecres",
  "Dijous",
  "Divendres",
  "Dissabte",
];

export const MONTHS = [
  "gener",
  "febrer",
  "març",
  "abril",
  "maig",
  "juny",
  "juliol",
  "agost",
  "setembre",
  "octubre",
  "novembre",
  "desembre",
];

export const TAGS = [
  "Familiar",
  "Tertúlia Literària",
  "Vermut",
  "Cinema",
  "Concert",
  "Teatre",
  "Exposició",
];

export const LOCATIONS_ARRAY = [
  { value: "Ajuntament de Cardedeu", label: "Ajuntament de Cardedeu" },
  { value: "Biblioteca Marc de Vilalba", label: "Biblioteca Marc de Vilalba" },
  { value: "Biblioteca Les Aigües", label: "Biblioteca Les Aigües" },
  { value: "Cambridge School Cardedeu", label: "Cambridge School Cardedeu" },
  {
    value: "Capella de Sant Corneli i Sant Cebrià",
    label: "Capella de Sant Corneli i Sant Cebrià",
  },
  { value: "Ca Espavil", label: "Ca l'Espavil" },
  { value: "Casa Corbella", label: "Casa Corbella" },
  { value: "Casa Viader", label: "Casa Viader" },
  {
    value: "Casal Ajuntament de Cardedeu",
    label: "Casal Ajuntament de Cardedeu",
  },
  { value: "Cementiri de Cardedeu", label: "Cementiri de Cardedeu" },
  { value: "Cervesa Sant Jordi", label: "Cervesa Sant Jordi" },
  { value: "Cinema Esbarjo", label: "Cinema Esbarjo" },
  { value: "Església de Santa Maria", label: "Església de Santa Maria" },
  { value: "Espai Totsona", label: "Espai Totsona" },
  { value: "Esbiosfera", label: "Esbiosfera" },
  { value: "Floristeria Parera", label: "Floristeria Parera" },
  { value: "Granja el Melindro", label: "Granja el Melindro" },
  { value: "Kid&Us Cardedeu", label: "Kid&Us Cardedeu" },
  { value: "La Fresca", label: "La Fresca" },
  { value: "L'estació és allà", label: "L'estació és allà" },
  {
    value: "La Guingueta del Pompeu Fabra",
    label: "La Guingueta del Pompeu Fabra",
  },
  { value: "La Terrassa de Viulamúsica", label: "La Terrassa de Viulamúsica" },
  { value: "Museu Arxiu Tomàs Balvey", label: "Museu Arxiu Tomàs Balvey" },
  { value: "Parc Pompeu Fabra", label: "Parc Pompeu Fabra" },
  { value: "Parc dels Pinetons", label: "Parc dels Pinetons" },
  { value: "Plaça de l'Església", label: "Plaça de l'Església" },
  { value: "Plaça Sant Corneli", label: "Plaça Sant Corneli" },
  { value: "Plaça Sant Joan", label: "Plaça Sant Joan" },
  { value: "Pla de la calma", label: "Pla de la calma" },
  {
    value: "Plaça dels Contes (Carrer Hospital i Teresa Oller)",
    label: "Plaça dels Contes (Carrer Hospital i Teresa Oller)",
  },
  { value: "Sala Sarau", label: "Sala Sarau" },
  { value: "Sant Hilari", label: "Sant Hilari" },
  { value: "Tarambana", label: "Tarambana" },
  { value: "Teatre Auditori Cardedeu", label: "Teatre Auditori Cardedeu" },
  {
    value: "Tèxtil Rase Fàbrica de Cultura",
    label: "Tèxtil Rase Fàbrica de Cultura",
  },
  { value: "Vil·la Paquita", label: "Vil·la Paquita" },
];

export const LOCATIONS = {
  ajuntamentCardedeu: ["ajuntament", "columnes"],
  bibliotecaMarcVilalba: ["vilalba"],
  bibliotecaLesAigues: ["aigues", "sec", "aigües"],
  cambridgeSchool: ["cambridge"],
  capellaSantCorneli: ["corneli"],
  casaCorbella: ["corbella"],
  caEspavil: ["l'espavil"],
  casaViader: ["viader"],
  casalAjuntamentCardedeu: ["gent gran"],
  canBorras: ["eureka"],
  cementiriCardedeu: ["cementiri"],
  cervesaSantJordi: ["cervesa", "jordi"],
  cinemaEsbarjo: ["esbarjo"],
  esglesiaSantaMaria: ["esglesia"],
  espai31: ["Espai31"],
  floristeriaParera: ["parera"],
  creperiaMelindro: ["melindro"],
  kidUsCardedeu: ["kid"],
  laFresca: ["fresca"],
  estacioAlla: ["estacio", "l'estació"],
  guinguetaPompeuFabra: ["guingueta"],
  terrassaViuLaMusica: ["terrassa"],
  museuArxiuTomasBalvey: ["museu"],
  parcPompeuFabra: ["pompeu"],
  parcDelsPinetons: ["pinetons"],
  placaContes: ["hospital", "oller", "contes"],
  placaEsglesia: ["l'església"],
  placaSantCorneli: ["corneli"],
  placaSantJoan: ["joan"],
  placaJoanAlsina: ["alsina"],
  plaCalma: ["calma"],
  salaSarau: ["sarau"],
  santHilari: ["hilari"],
  tarambana: ["tarambana"],
  teatreAuditoriCardedeu: ["teatre", "auditori"],
  textilRase: ["textil", "rase"],
  vilaPaquita: ["paquita"],
  totsona: ["totsona"],
  polvori: ["polvori", "polvorí"],
  garitu: ["garitu"],
  esbiosfera: ["esbiosfera"],
};

export const VITAMINED_LOCATIONS = {
  ajuntamentCardedeu: {
    images: [
      "/static/images/locations/ajuntamentCardedeu/1.jpeg",
      "/static/images/locations/ajuntamentCardedeu/2.jpeg",
    ],
    social: {
      web: "https://www.cardedeu.cat/",
      twitter: "https://twitter.com/ajcardedeu",
      facebook:
        "https://www.facebook.com/Ajuntament-de-Cardedeu-113512225387206/",
      instagram: "https://www.instagram.com/ajcardedeu/",
    },
  },
  bibliotecaMarcVilalba: {
    images: [
      "/static/images/locations/bibliotecaMarcVilalba/1.jpeg",
      "/static/images/locations/bibliotecaMarcVilalba/2.jpeg",
    ],
    social: {
      web: "https://www.bibliotecacardedeu.cat/",
      twitter: "https://twitter.com/bibliocardedeu",
      facebook: "https://www.facebook.com/bibliocardedeu/",
      instagram: "http://instagram.com/bibliocardedeu",
    },
  },
  bibliotecaLesAigues: {
    images: [
      "/static/images/locations/bibliotecaLesAigues/1.jpeg",
      "/static/images/locations/bibliotecaLesAigues/2.jpeg",
    ],
    social: {
      web: "https://agora.xtec.cat/lesaigues/biblioteca/",
    },
  },
  cambridgeSchool: {
    images: ["/static/images/locations/cambridgeSchool/1.jpeg"],
    social: {
      web: "https://www.cambridgeschool.com/es/escuela-idiomas-cardedeu.html",
    },
  },
  capellaSantCorneli: {
    images: [
      "/static/images/locations/capellaSantCorneli/1.jpeg",
      "/static/images/locations/capellaSantCorneli/2.jpeg",
    ],
    social: {
      twitter: "https://www.twitter.com/culturacardedeu",
      instagram: "https://www.instagram.com/culturacardedeu",
      telegram: "htpps://t.me/culturacardedeu",
      facebook: "https://www.facebook.com/agendaculturacardedeu",
    },
  },
  canBorras: {
    images: ["/static/images/locations/canBorras/1.jpeg"],
    social: {
      web: "https://www.cardedeu.cat/serveis-i-tramits/oficines-municipals-punts-dinformacio-ciutadana/can-borras-accio-social-educacio-igualtat-i-gent-gran.html",
    },
  },
  cardedeu: {
    images: [
      "/static/images/locations/cardedeu/1.jpeg",
      "/static/images/locations/cardedeu/2.jpeg",
    ],
    social: {
      twitter: "https://www.twitter.com/culturacardedeu",
      instagram: "https://www.instagram.com/culturacardedeu",
      telegram: "htpps://t.me/culturacardedeu",
      facebook: "https://www.facebook.com/agendaculturacardedeu",
    },
  },
  casaCorbella: {
    images: ["/static/images/locations/casaCorbella/1.jpeg"],
    social: {
      twitter: "https://www.twitter.com/culturacardedeu",
      instagram: "https://www.instagram.com/culturacardedeu",
      telegram: "htpps://t.me/culturacardedeu",
      facebook: "https://www.facebook.com/agendaculturacardedeu",
    },
  },
  caEspavil: {
    images: ["/static/images/locations/caEspavil/1.jpeg"],
    social: {
      web: "http://www.calespavil.cat/",
    },
  },
  casaViader: {
    images: [
      "/static/images/locations/casaViader/1.jpeg",
      "/static/images/locations/casaViader/2.jpeg",
    ],
    social: {
      twitter: "https://www.twitter.com/culturacardedeu",
      instagram: "https://www.instagram.com/culturacardedeu",
      telegram: "htpps://t.me/culturacardedeu",
      facebook: "https://www.facebook.com/agendaculturacardedeu",
    },
  },
  casalAjuntamentCardedeu: {
    images: [
      "/static/images/locations/casalAjuntamentCardedeu/1.jpeg",
      "/static/images/locations/casalAjuntamentCardedeu/2.jpeg",
    ],
    social: {
      web: "https://www.cardedeu.cat/el-municipi/equipaments/casal-de-la-gent-gran.html",
    },
  },
  cementiriCardedeu: {
    images: [
      "/static/images/locations/cementiriCardedeu/1.jpeg",
      "/static/images/locations/cementiriCardedeu/2.jpeg",
    ],
    social: {
      web: "https://www.cardedeu.cat/el-municipi/equipaments/cementiri-municipal.html",
    },
  },
  cervesaSantJordi: {
    images: [
      "/static/images/locations/cervesaSantJordi/1.jpeg",
      "/static/images/locations/cervesaSantJordi/2.jpeg",
    ],
    social: {
      web: "https://www.cervesasantjordi.cat/",
      instagram: "https://www.instagram.com/cervesasantjordi/",
      facebook: "https://www.facebook.com/Cervesa-Sant-Jordi-744578365569842/",
    },
  },
  cinemaEsbarjo: {
    images: [
      "/static/images/locations/cinemaEsbarjo/1.jpeg",
      "/static/images/locations/cinemaEsbarjo/2.jpeg",
    ],
    social: {
      web: "http://www.cinemaesbarjo.cat/",
      instagram: "https://www.instagram.com/cinemaesbarjo/",
      facebook: "http://www.facebook.com/cinemaesbarjo",
      twitter: "https://twitter.com/cinemaesbarjo",
    },
  },
  esglesiaSantaMaria: {
    images: [
      "/static/images/locations/esglesiaSantaMaria/1.jpeg",
      "/static/images/locations/esglesiaSantaMaria/2.jpeg",
    ],
    social: {
      web: "https://santamariacardedeu.com/",
    },
  },
  espai31: {
    images: ["/static/images/locations/espai31/1.jpeg"],
    social: {
      web: "https://espai31.cat/",
      facebook: "https://www.facebook.com/llibreriaespai31",
      twitter: "https://twitter.com/llibreriaE31",
      instagram: "https://www.instagram.com/llibreriaespai31/",
    },
  },
  floristeriaParera: {
    images: ["/static/images/locations/floristeriaParera/1.jpeg"],
    social: {
      instagram: "https://www.instagram.com/floristeriaparera/",
    },
  },
  creperiaMelindro: {
    images: ["/static/images/locations/creperiaMelindro/1.jpeg"],
    social: {
      web: "http://www.elmelindro.cat/",
      facebook: "https://www.facebook.com/elmelindro",
      instagram: "https://www.instagram.com/el_melindro/",
    },
  },
  kidUsCardedeu: {
    images: ["/static/images/locations/kidUsCardedeu/1.jpeg"],
    social: {
      web: "https://cardedeu.kidsandus.es/ca/",
      instagram: "https://www.instagram.com/kidsandus.cardedeu/?hl=en",
      facebook: "https://www.facebook.com/KidsUs-Cardedeu-101837365368110",
      twitter: "https://twitter.com/kids_us",
    },
  },
  laFresca: {
    images: [
      "/static/images/locations/laFresca/1.jpeg",
      "/static/images/locations/laFresca/2.jpeg",
    ],
    social: {
      web: "https://lafresca.eco/",
      facebook:
        "https://m.facebook.com/people/La-Fresca-Cardedeu/100073163559518/",
    },
  },
  guinguetaPompeuFabra: {
    images: [
      "/static/images/locations/guinguetaPompeuFabra/1.jpeg",
      "/static/images/locations/guinguetaPompeuFabra/2.jpeg",
    ],
    social: {
      web: "https://laguinguetadelpompeufabra.cat/",
      facebook: "https://www.facebook.com/laguinguetadelpompeufabra/",
      twitter: "https://twitter.com/laguingueta_",
      instagram: "https://www.instagram.com/laguinguetadelpompeu/",
    },
  },
  terrassaViuLaMusica: {
    images: [
      "/static/images/locations/terrassaViuLaMusica/1.jpeg",
      "/static/images/locations/terrassaViuLaMusica/2.jpeg",
    ],
    social: {
      web: "http://viulamusica.cat/",
      facebook: "https://www.facebook.com/escolaviulamusica/",
      instagram: "https://www.instagram.com/viulamusicacardedeu/",
      twitter: "https://twitter.com/viulamusica",
    },
  },
  museuArxiuTomasBalvey: {
    images: [
      "/static/images/locations/museuArxiuTomasBalvey/1.jpeg",
      "/static/images/locations/museuArxiuTomasBalvey/2.jpeg",
    ],
    social: {
      web: "https://museudecardedeu.cat/",
      instagram: "https://www.instagram.com/museudecardedeu/",
      facebook:
        "https://www.facebook.com/pages/Museu-Arxiu-Tom%C3%A0s-Balvey-MATBC/441944045897953?fref=ts",
    },
  },
  parcPompeuFabra: {
    images: ["/static/images/locations/parcPompeuFabra/1.jpeg"],
    social: {
      twitter: "https://www.twitter.com/culturacardedeu",
      instagram: "https://www.instagram.com/culturacardedeu",
      telegram: "htpps://t.me/culturacardedeu",
      facebook: "https://www.facebook.com/agendaculturacardedeu",
    },
  },
  parcDelsPinetons: {
    images: ["/static/images/locations/parcDelsPinetons/1.jpeg"],
    social: {
      twitter: "https://www.twitter.com/culturacardedeu",
      instagram: "https://www.instagram.com/culturacardedeu",
      telegram: "https://t.me/culturacardedeu",
      facebook: "https://www.facebook.com/agendaculturacardedeu",
    },
  },
  placaContes: {
    images: [
      "/static/images/locations/placaContes/1.jpeg",
      "/static/images/locations/placaContes/2.jpeg",
    ],
    social: {
      twitter: "https://www.twitter.com/culturacardedeu",
      instagram: "https://www.instagram.com/culturacardedeu",
      telegram: "htpps://t.me/culturacardedeu",
      facebook: "https://www.facebook.com/agendaculturacardedeu",
    },
  },
  placaEsglesia: {
    images: ["/static/images/locations/placaEsglesia/1.jpeg"],
    social: {
      twitter: "https://www.twitter.com/culturacardedeu",
      instagram: "https://www.instagram.com/culturacardedeu",
      telegram: "htpps://t.me/culturacardedeu",
      facebook: "https://www.facebook.com/agendaculturacardedeu",
    },
  },
  placaSantCorneli: {
    images: ["/static/images/locations/placaSantCorneli/1.jpeg"],
    social: {
      twitter: "https://www.twitter.com/culturacardedeu",
      instagram: "https://www.instagram.com/culturacardedeu",
      telegram: "htpps://t.me/culturacardedeu",
      facebook: "https://www.facebook.com/agendaculturacardedeu",
    },
  },
  placaSantJoan: {
    images: ["/static/images/locations/placaSantJoan/1.jpeg"],
    social: {
      twitter: "https://www.twitter.com/culturacardedeu",
      instagram: "https://www.instagram.com/culturacardedeu",
      telegram: "htpps://t.me/culturacardedeu",
      facebook: "https://www.facebook.com/agendaculturacardedeu",
    },
  },
  placaJoanAlsina: {
    images: ["/static/images/locations/placaJoanAlsina/1.jpeg"],
    social: {
      twitter: "https://www.twitter.com/culturacardedeu",
      instagram: "https://www.instagram.com/culturacardedeu",
      telegram: "htpps://t.me/culturacardedeu",
      facebook: "https://www.facebook.com/agendaculturacardedeu",
    },
  },
  plaCalma: {
    images: [
      "/static/images/locations/plaCalma/1.jpeg",
      "/static/images/locations/plaCalma/2.jpeg",
    ],
    social: {
      facebook: "https://www.facebook.com/barpladelacalma/",
    },
  },
  salaSarau: {
    images: ["/static/images/locations/salaSarau/1.jpeg"],
    social: {
      web: "https://www.cardedeu.cat/adreces-i-telefons/sala-sarau.html",
    },
  },
  santHilari: {
    images: [
      "/static/images/locations/santHilari/1.jpeg",
      "/static/images/locations/santHilari/2.jpeg",
    ],
    social: {
      web: "https://www.cardedeu.cat/el-municipi/equipaments/mas-de-sant-hilari.html",
    },
  },
  tarambana: {
    images: [
      "/static/images/locations/tarambana/1.jpeg",
      "/static/images/locations/tarambana/2.jpeg",
    ],
    social: {
      web: "https://tarambana.cat/",
      twitter: "https://twitter.com/eltarambana",
      facebook: "https://www.facebook.com/tarambana.cardedeu",
      instagram: "https://www.instagram.com/tarambanacardedeu/",
    },
  },
  teatreAuditoriCardedeu: {
    images: [
      "/static/images/locations/teatreAuditoriCardedeu/1.jpeg",
      "/static/images/locations/teatreAuditoriCardedeu/2.jpeg",
    ],
    social: {
      web: "https://www.teatreauditoricardedeu.cat/",
      twitter: "https://twitter.com/teatrecardedeu",
      facebook: "https://www.facebook.com/TeatredeCardedeu",
      instagram: "https://www.instagram.com/teatredecardedeu/",
    },
  },
  textilRase: {
    images: [
      "/static/images/locations/textilRase/1.jpeg",
      "/static/images/locations/textilRase/2.jpeg",
    ],
    social: {
      web: "https://www.cardedeu.cat/el-municipi/equipaments/sala-polivalent-textil-rase.html",
      facebook: "https://www.facebook.com/textilrase/",
      instagram: "https://www.instagram.com/textilrase/?hl=en",
    },
  },
  vilaPaquita: {
    images: [
      "/static/images/locations/vilaPaquita/1.jpeg",
      "/static/images/locations/vilaPaquita/2.jpeg",
    ],
    social: {
      web: "https://www.cardedeu.cat/serveis-i-tramits/oficines-municipals-punts-dinformacio-ciutadana/villa-paquita-cultura-participacio-i-joventut.html",
    },
  },
  totsona: {
    images: ["/static/images/locations/totsona/1.jpeg"],
    social: {
      web: "https://www.totsona.com/",
      facebook: "https://www.facebook.com/damarisgelabert",
      twitter: "https://twitter.com/damarisgelabert",
    },
  },
  polvori: {
    images: [
      "/static/images/locations/polvori/1.jpeg",
      "/static/images/locations/polvori/2.jpeg",
    ],
    social: {
      web: "https://elpolvori.wordpress.com/",
      facebook: "https://www.facebook.com/ElPolvori/",
      twitter: "https://www.facebook.com/ElPolvori/",
      instagram: "https://www.instagram.com/elpolvori/?hl=en",
    },
  },
  garitu: {
    images: [
      "/static/images/locations/garitu/1.jpeg",
      "/static/images/locations/garitu/2.jpeg",
    ],
    social: {
      web: "https://elgaritu.cat/",
      facebook: "https://www.facebook.com/elgaritucardedeu",
      twitter: "https://twitter.com/elgaritu",
      instagram: "https://www.instagram.com/elgaritu",
    },
  },
  esbiosfera: {
    images: [
      "/static/images/locations/esbiosfera/1.jpeg",
      "/static/images/locations/esbiosfera/2.jpeg",
    ],
    social: {
      web: "http://www.esbioesfera.cat/",
      facebook: "https://www.facebook.com/326643577355325",
    },
  },
  estacioAlla: {
    images: ["/static/images/locations/estacioAlla/1.jpeg"],
    social: {
      web: "http://lestacioesalla.blogspot.com.es/",
    },
  },
};
